export class RecogField {
  id: number
  seq_no: number
  sheet_field_id: number
  page: number
  x: number
  y: number
  width: number
  height: number
  part1: string
  part2: string
  part3: string
  is_mark: boolean
  is_correct: boolean = false

  get fieldName(): string{
    let rtn = "";
    if(this.part1 != null){
      rtn += this.part1;
    }
    if(this.part2 != null){
      rtn += ` ${this.part2}`
    }
    if(this.part3 != null){
      rtn += ` ${this.part3}`
    }
    return rtn;
  }

  constructor(recogField: any){
    this.id = recogField.id;
    this.seq_no = recogField.seq_no;
    this.sheet_field_id = recogField.sheet_field_id;
    this.page = recogField.page;
    this.x = recogField.x;
    this.y = recogField.y;
    this.width = recogField.width;
    this.height = recogField.height;
    this.part1 = recogField.part1;
    this.part2 = recogField.part2;
    this.part3 = recogField.part3;
    this.is_mark = recogField.is_mark;
    if(this.is_mark){
      this.is_correct = recogField.correct_mark_nos.includes(recogField.seq_no);
    }
  }
}

export interface SheetField {
  id: number
  page: number
  rim: number[]
  mark_count: number[]
}

export class FieldItem{
  recogField: RecogField | null = null
  key: number = 0
  sortNo: number = 0
  x: number = 0
  y: number = 0
  width: number = 0
  height: number = 0
  isActive: boolean = false
}


export class PageItem{
  pageNo: number
  base64Image: string
  baseWidth: number
  baseHeight: number
  recogFields: RecogField[] = new Array<RecogField>()
  fieldItems: FieldItem[] = new Array<FieldItem>()

  constructor(pageNo: number, base64Image: string, baseWidth: number, baseHeight: number){
    this.pageNo = pageNo;
    this.baseWidth = baseWidth;
    this.baseHeight = baseHeight;
    this.base64Image = base64Image;
  }
}

export class Pos {
  x: number
  y: number

  constructor(x: number, y: number){
    this.x = x;
    this.y = y;
  }
}